module.exports = __webpack_public_path__ + "img/test_icon.a8ede4a3.svg";